module.exports = __webpack_public_path__ + "static/media/18ECA33.ee7f0d74.jpg";